import { Loader2 } from 'lucide-react';

const variants = {
  primary: 'bg-primary text-white hover:bg-primary-dark shadow-sm',
  secondary: 'bg-gray-50 text-gray-700 border border-gray-200 hover:bg-gray-100',
  tertiary: 'text-primary hover:opacity-80',
  danger: 'bg-red-500 text-white hover:bg-red-600',
  outline: 'border border-primary text-primary hover:bg-primary hover:!text-white',
};
const sizes = { sm: 'py-2 px-4 text-sm rounded-lg', md: 'py-3 px-5 rounded-xl', lg: 'py-4 px-6 rounded-xl' };

const Button = ({ children, variant = 'primary', size = 'md', loading = false, disabled = false, fullWidth = false, className = '', type = 'button', onClick, ...props }) => (
  <button
    type={type}
    className={`font-semibold transition-all duration-200 active:scale-[0.98] inline-flex items-center justify-center gap-2 ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${fullWidth ? 'w-full' : ''} ${disabled || loading ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    disabled={disabled || loading}
    onClick={onClick}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 animate-spin" />}
    {children}
  </button>
);

export default Button;
